import BaseAPI from "./BaseAPI";
import { foodRecordItemRoute } from "../routes";

export default class FoodRecordItemAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, foodRecordItemRoute, "food-record-item");
    }

    async ListNames() {
        return this._request("get", this._url("/names"));
    }
}
